import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
export default function Join(_ref) {
  var children = _ref.children,
      separator = _ref.separator,
      itemRender = _ref.itemRender;
  var elements = [];
  children.forEach(function (fragment, i) {
    if (i !== 0) {
      elements.push( /*#__PURE__*/React.createElement(Fragment, {
        key: "k".concat(i)
      }, separator));
    }

    elements.push( /*#__PURE__*/React.createElement(Fragment, {
      key: "f".concat(i)
    }, itemRender(fragment)));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, elements);
}
Join.propTypes = {
  children: PropTypes.array,
  separator: PropTypes.node,
  itemRender: PropTypes.func
};
Join.defaultProps = {
  children: [],
  separator: '',
  itemRender: function itemRender(x) {
    return x;
  }
};